// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { commonEnvironment } from './environment.common';

export const environment = {
  version: commonEnvironment.version,
  production: commonEnvironment.production,
  TVA: 0.2,

  api: {
    mobilityUrl: '',
    financialUrl: '',
    sharedDataManager: '', // to delete
    kibanaUrl: '',
    apikey: '' // to delete
  },

  /*************
   * KEYCLOAK
   *************/
  keycloak: {
    url: 'https://keycloak-t2u-produits-dakar.apps.dev.caas4noprd.worldline-solutions.com/auth',
    realm: 'tap2useAdmin',
    clientId: 'admin-portal'
  },

  passenger: {
    userOrigin: 'tap2usePassenger',
    userClient: 'passenger-portal'
  },

  /*************
   * KIBANA
   *************/
  kibana: {
    dashboardId: ''
  },

  /**********************************************************
   * APPLICATION
   *   Define main application parameters (favicon, title...)
   **********************************************************/
  application: {
    title: 'MaaS - Admin Portal',
    favicon: './assets/images/brand/favicon.png',
    menuicon: './assets/images/logo-admin.png'
  },

  /*************
   * ROLES
   *************/
  roles: ["ROOT_ADMIN", "SUPER_ADMIN", "SAV"],

  userAccountPhoto: {
    type: "THUMBNAIL",
    maxSize: {
      active: true,
      value: "768000"
    },
    allowedRatio: {
      active: true,
      value: ['1:1', '4:3', '16:9', '3:2', '5:4', '8:1', '2:35', '1:85', '21:9', '9:16']
    }
  },

  access: {
    createUser: true
  },

  user: {
    accountTypesNotEditable: []
  },

  defaultValue: {
    user: {
      maxYearOld: 18,
      crud: ['CREATE', 'UPDATE', 'DELETE', 'ENROLL'],
      actortypeagent: 'AGENT',
      accountState: {
        cancelled: 'CANCELLED'
      },
    }
  },

  maasProduct: {
    parameters: {
      configProperties: {
        applicationList: []
      }
    }
  },

  airweb: {
    env: 'develop'
  },

  opp: {
    tokenizerUrl: "https://payment.preprod.direct.worldline-solutions.com"
  },
  maintenance: {
    enabled: false,
    from: null,
    to: null,
    message: "",
    banner: {
      enabled: false,
      message: "",
      displayBefore: ""
    }
  }
};
